import { Component, OnInit, Input, HostListener, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Estudo } from './estudo';
import { EstudoService } from './estudo.service';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Questionario } from 'unb-questionario-componente';
import { SituacaoEnum } from '../util/situacao.enum';

@Component( {
  selector: 'estudo-detail',
  templateUrl: './estudo-detail.component.html',
  styleUrls: [ './estudo-detail.component.css' ]
} )
export class EstudoDetailComponent implements OnInit, AfterViewInit  {
    public estudo: Estudo;
    public params_subscription: any;
    public isLoading: boolean;
    public ehAluno = true;
    public filtro: string;
    public estaDuplicandoEstudo = true; // contra a duplicacao. Pra evitar q o aluno prossiga enquanto esta duplicando

    public posicao_atual: number;
    // Esses class sao referentes aos CSS de cada aba.
    public class_1: string; // 1.Introducao
    public class_2: string; // 2.EstudoPreliminar
    public class_3: string; // 3.DadosPessoais
    public class_4: string; // 4.GrupoFamiliar
    public class_5: string; // 5.Conclusao
    public larguraTela: number = window.innerWidth;

    public perfilPreliminar: boolean;


    @Input() sub = false;

    constructor(private route: ActivatedRoute,
      private router: Router,
      private estudoService: EstudoService,
      private mensagem: MatSnackBar,
      private respostaService: RespostaListaDinamicaService)   {
    }

    ngOnInit()  {
        this.posicao_atual = 1;
        this.controlaClasse();
        const id: any = this.route.snapshot.params['id'];
        const matricula: any = this.route.snapshot.params['matricula'];
        const sub: any = this.route.snapshot.params['sub'];
        this.filtro = this.route.snapshot.params['filtro'];

        if (sub) { // se essa variavel chegar preenchida entao nah eh aluno
            this.ehAluno = false;
            this.estaDuplicandoEstudo = false;
        }

        if (id && id !== 'new')  {
          this.isLoading = true;
          this.estudoService.getId(parseInt(id)).subscribe(
            result =>  {
              this.estudo = result;
              this.controlaPreliminar();
            } ,
            error => this.erro(error)
          );
        } else if (matricula) {
          this.estudoService.getEstudoPorMatricula(matricula).subscribe(
            result =>  {
              this.estaDuplicandoEstudo = false;
              this.estudo = result;
              this.controlaPreliminar();
            } ,
            error => this.erro(error)
          );
        } else  {
          this.inicializaEstudo();
        }
    }

    ngAfterViewInit()  {
      this.larguraTela = window.innerWidth;
  }

    // if screen size changes it'll update
    @HostListener('window:resize', ['$event'])
    resize(event)  {
        this.larguraTela = window.innerWidth;
    }

  controlaPreliminar() {
    this.estaDuplicandoEstudo = false;
    if (this.estudo.respostaQuestionarioPreliminar) {
      this.estudoService.verificaPerfilEstudoPreliminar(this.estudo.id).subscribe ( (result: boolean) =>  {
        this.perfilPreliminar = result;
        this.isLoading = false;
      } );
    } else {
      // se ele nao tiver, entao eu deixo ver tudo mesmo.
      this.isLoading = false;
      this.perfilPreliminar = true;
    }
  }

  inicializaEstudo() {
    this.isLoading = true;
      this.estudoService.inicializa().subscribe(
        (result: Estudo) => {
          // se o estudo não tem id, então eh novo. Aí eu tento compiar ele.
          this.estudo = result;
          if (!result.id) {
            this.duplicaEstudo(result);
          } else {
            this.estaDuplicandoEstudo = false;
            this.controlaPreliminar();
          }
        } ,
        error => this.erro(error)
      );
  }

  duplicaEstudo(estudo: Estudo) {
    const filtro: Estudo = new Estudo();
    filtro.aluno = estudo.aluno;

    this.estudoService.filtrar(filtro,  'dataInclusao asc ').subscribe((results: Estudo[]) =>  {
      if (results && results.length > 0) {
        const ultimoEstudo = results[0]; // pego o primeiro resultado
        if (ultimoEstudo.respostaQuestionarioDadosPessoais != null) {
          this.mensagem.open( 'Duplicando seu estudo anterior. Pode ser que isto demore um pouco... ', 'X',  {duration: 8000} );
            this.estaDuplicandoEstudo = true;
            this.estudoService.duplicar(estudo).subscribe((result: Estudo) => {
              this.estudo = result;
              this.estaDuplicandoEstudo = false;
              this.controlaPreliminar();
            }, error => this.erro(error)
          );
        }else{
          this.estaDuplicandoEstudo = false;
          this.isLoading  = false;
        }
      } else  {
        this.controlaPreliminar();
      }
    } , error => this.erro(error));
  }

    // mostra erros na tela
   erro(erro: string) {
       this.mensagem.open(erro, 'X',  {duration: 5000} );
       this.isLoading = false;
   }

   // finaliza o subscribe
   proximoEmitido(abaAtual: number) {
    this.posicao_atual = abaAtual + 1;
    this.controlaClasse();
   }

   anteriorEmitido(abaAtual: number) {
     this.posicao_atual = abaAtual - 1;
     this.controlaClasse();
   }

   estudoEmitido(estudo: Estudo) {
     this.estudo = estudo;
     this.controlaPreliminar();
   }

   questionarioPreliminarRecebido(questionario: Questionario) {
     this.estudo.questionarioPreliminar = questionario;
   }

   questionarioDadosRecebido(questionario: Questionario) {
     this.estudo.questionarioDadosPessoais = questionario;
   }

   questionarioGrupoRecebido(questionario: Questionario) {
     this.estudo.questionarioGrupoFamiliar = questionario;
   }

   instrucao() {
     // basicamente isso: se nao for aluno, pode deixar clicar.
     // ou se for aluno, e tiver estudo, e o estudo for diferente de NaoConcluido pode entrar
     // fizemos isso pra evitar que o aluno fique preenchendo as abas e navegando ao mesmo tempo.
     // muitos não salvavam e perdiam os dados.
     if (!this.ehAluno || (this.ehAluno && this.estudo && this.estudo.situacao !== SituacaoEnum.NaoConcluido)) {
       this.posicao_atual = 1;
       this.controlaClasse();
     }
   }
   estudo_preliminar() {
     if (!this.ehAluno || (this.ehAluno && this.estudo && this.estudo.situacao !== SituacaoEnum.NaoConcluido)) {
       this.posicao_atual = 2;
       this.controlaClasse();
     }
   }
   dados_pessoais() {
     if (!this.ehAluno || (this.ehAluno && this.estudo && this.estudo.situacao !== SituacaoEnum.NaoConcluido)) {
       this.posicao_atual = 3;
       this.controlaClasse();
     }
   }
   grupo_familiar() {
     if (!this.ehAluno || (this.ehAluno && this.estudo && this.estudo.situacao !== SituacaoEnum.NaoConcluido)) {
       this.posicao_atual = 4;
       this.controlaClasse();
     }
   }
   conclusao() {
     if (!this.ehAluno || (this.ehAluno && this.estudo && this.estudo.situacao !== SituacaoEnum.NaoConcluido)) {
       this.posicao_atual = 5;
       this.controlaClasse();
     }
   }

   controlaClasse() {
     if (this.posicao_atual === 1) {
       this.class_1 =  'current ';
       this.class_2 =  'disabled ';
       this.class_3 =  'disabled ';
       this.class_4 =  'disabled ';
       this.class_5 =  'disabled ';
     } else if (this.posicao_atual === 2) {
       this.class_1 =  'done ';
       this.class_2 =  'current ';
       this.class_3 =  'disabled ';
       this.class_4 =  'disabled ';
       this.class_5 =  'disabled ';
     } else if (this.posicao_atual === 3) {
       this.class_1 =  'done ';
       this.class_2 =  'done ';
       this.class_3 =  'current ';
       this.class_4 =  'disabled ';
       this.class_5 =  'disabled ';
     } else if (this.posicao_atual === 4) {
       this.class_1 =  'done ';
       this.class_2 =  'done ';
       this.class_3 =  'done ';
       this.class_4 =  'current ';
       this.class_5 =  'disabled ';
     } else if (this.posicao_atual === 5) {
       this.class_1 =  'done ';
       this.class_2 =  'done ';
       this.class_3 =  'done ';
       this.class_4 =  'done ';
       this.class_5 =  'current ';
     }
   }

   voltar() {
    this.router.navigate(['/estudolist',  {filtro: this.filtro} ]);
   }


}
